export const messages = {
    addMedia: 'Add New Media',
    confirmMedia: 'Confirm Media',
    externalLink: 'Enter Media URL here...',
    mediaUrl: 'Media URL',
    noMedia: 'No Media',
    uploadMedia: 'Select File to Upload',
};
